export default {
  promoBanner: {
    mcp: {
      badge: 'MCP',
      title: 'Supercharge your workflow with BEEM MCP',
      subtitle: 'Query your data warehouse, explore dashboards, and manage pipelines — right from your AI tools.',
      cta: 'Install MCP',
    },
  },
};
